"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  demurrageCalculation: {
    title: 'DEM/DET Calculation',
    DEMDETFee: 'DEM&DET Fee',
    date: 'Calculate Date',
    tips_1: '*Blue：End Of Today',
    tips_2: '*Red：Assign Date Charge',
    tips_3: '*Black：Actual Charge',
    tips_4: '(2)  The calculation results are for reference only and cannot be used as the basis for final payment;Container that cannot obtain results does not mean that no fees have been incurred.',
    blCtNoNotNull: 'B/L No.,Container No. Not Null',
    portName: 'Port',
    freeUntil: 'Free Until',
    days: 'Days',
    overDays: 'Over Days',
    demurrageType: 'DEM/DET',
    agreementNo: 'FT No.'
  }
};